import React from 'react';
import { CheckIcon, GiftIcon, LockIcon } from 'lucide-react';
import { valueStack } from '../data/tomos';
import { PRECIO_HOY, VALOR_TOTAL } from '../data/oferta';
import { CtaButton } from './CtaButton';
export function ValueStack() {
  return <section id="checkout" className="w-full bg-ink py-14 sm:py-20" data-id="element-116" data-mp="1qa5xo1a7nlf7">
      <div className="mx-auto max-w-3xl px-5" data-id="element-117" data-mp="1uazl6tjqqy7k">
        <h2 className="text-center text-2xl font-black leading-tight tracking-tight text-white sm:text-[2rem]" data-id="element-118" data-mp="1ubric8szl3zy">
          Todo lo que te llevas hoy
        </h2>

        <ul className="mt-9 divide-y divide-white/10 rounded-2xl bg-white/[0.04] px-6 py-2 ring-1 ring-white/10" data-id="element-119" data-mp="2mxaowd2n9f8l">
          {valueStack.map(item => <li key={item.nombre} className="flex items-center justify-between gap-4 py-4" data-id="element-120" data-mp="2d8kcs8dw4avv">
              <span className="flex items-start gap-3 text-[15px] font-semibold leading-snug text-white sm:text-base" data-id="element-121" data-mp="30xbw0a9i5iwi">
                {item.bono ? <GiftIcon className="mt-0.5 h-4 w-4 shrink-0 text-flame" aria-hidden="true" data-id="element-122" data-mp="1tfcx6zc2rfwp" /> : <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-leaf" aria-hidden="true" data-id="element-123" data-mp="1oi37dikrx28c" />}
                {item.nombre}
              </span>
              <span className="shrink-0 font-mono text-sm tabular-nums text-white/50 line-through" data-id="element-124" data-mp="2c5um0stsdrcs">
                {item.valor}
              </span>
            </li>)}
        </ul>

        <div className="mt-8 text-center" data-id="element-125" data-mp="286ls9nyqxth8">
          <p className="text-sm font-semibold uppercase tracking-[0.15em] text-white/50" data-id="element-126" data-mp="2m4abkrd60sk6">
            Valor total: <span className="line-through" data-id="element-127" data-mp="2h5z4goe98w5n">{VALOR_TOTAL}</span>
          </p>
          <p className="mt-3 text-sm font-bold uppercase tracking-[0.15em] text-flame" data-id="element-128" data-mp="rphk94jbeny1">
            Precio especial hoy
          </p>
          <p className="mt-1 text-6xl font-black tracking-tighter text-white sm:text-7xl" data-id="element-129" data-mp="ms7wrufhkmcu">
            {PRECIO_HOY}
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-130" data-mp="2rs908gipsj23">
          <CtaButton className="text-base leading-snug sm:text-lg" data-id="element-131" data-mp="2rssjc0k3pdhp">
            👉 ¡Sí! Quiero el Megapack y eliminar los piojos ahora por {PRECIO_HOY}
          </CtaButton>
          <p className="mt-4 flex items-center gap-2 text-sm font-medium text-white/60" data-id="element-132" data-mp="30t75f24w2wm9">
            <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-133" data-mp="35sjt1p3l47pw" />
            Pago seguro · Acceso inmediato, incluso si son las 3 AM.
          </p>
        </div>
      </div>
    </section>;
}